module.exports = __webpack_public_path__ + "img/logo.d348d9d1.png";